import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Button, DataTable, DataTablePagination } from 'components/common'
import { useQuery } from 'hooks'
import {
  fetchTalabatSyncLogs,
  triggerPromotionJobPoll,
} from 'utils/api/logsApi'
import { getColumns } from './utils'
import toast from 'react-hot-toast'
import { AxiosError } from 'axios'
import { filterEmptyValues, FilterMeta } from 'utils/helpers'
import { FILTER_FIELD_TALABAT_LOG } from './talabatLogFilterForm'

type Props = {
  onFilterMeta?: (filterMeta: FilterMeta) => void
}

const TalabatLogTable = ({ onFilterMeta }: Props) => {
  const [logResponse, setLogResponse] = useState<any>({})
  const [isPollLoading, setIsPollLoading] = useState(false)

  const { search } = useLocation()
  const { getAllQueries } = useQuery()
  const columns = useMemo(() => getColumns(), [])

  // To get Talabat Log data
  const getLogs = async () => {
    try {
      const queries = getAllQueries()
      const filters = filterEmptyValues(queries[FILTER_FIELD_TALABAT_LOG] || {})

      const { data } = await fetchTalabatSyncLogs({
        limit: queries.limit || 10,
        page: queries.page || 1,
        filters,
      })
      setLogResponse(data)
      if (data?.filterMeta) {
        onFilterMeta?.(data.filterMeta)
      }
    } catch (error) {
      setLogResponse({ docs: [] })
    }
  }

  useEffect(() => {
    getLogs()
  }, [search])

  const handlePollPromotionJobs = async () => {
    const loadingToast = toast.loading('Initializing Promotion Job Poll', {
      duration: Infinity,
    })

    setIsPollLoading(true)

    try {
      await triggerPromotionJobPoll()

      toast.success('Promotion Job Poll Initiated', {
        id: loadingToast,
        duration: 3000,
      })
    } catch (error) {
      if (error instanceof AxiosError) {
        if (error?.response?.data?.errors?.msg?.runningService) {
          return toast.error(error.response.data.errors.msg.runningService, {
            id: loadingToast,
            duration: 3000,
          })
        }
      }
      toast.error('Error initiating Promotion Job Poll', {
        id: loadingToast,
        duration: 3000,
      })
    } finally {
      setIsPollLoading(false)
    }
  }

  return (
    <>
      <Button
        type="button"
        variant="outline"
        buttonText="Poll Promotion Jobs"
        loading={isPollLoading}
        onClick={handlePollPromotionJobs}
        className="mb-4"
      />
      <DataTable columns={columns} rows={logResponse?.docs} identifier="_id" />

      {/* Table Pagination */}
      <DataTablePagination
        currentPage={logResponse?.page}
        totalPages={logResponse?.totalPages}
        hasNextPage={logResponse?.hasNextPage}
        hasPrevPage={logResponse?.hasPrevPage}
        limit={logResponse?.limit}
        nextPage={logResponse?.nextPage}
        prevPage={logResponse?.prevPage}
      />
    </>
  )
}

export default TalabatLogTable
